import React, { Component } from "react";
import { Link } from "react-router-dom";

class FeaturesV1 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let customClass = this.props.customClass ? this.props.customClass : "";

    let list = [
      {
		id: 101,
        name: "Home Automation",
        logo: publicUrl + "assets/img/icons/icon-img/21.png"
      },
      {
		id: 102,
        name: "Audio Video",
        logo: publicUrl + "assets/img/icons/icon-img/25.png",
      },
      {
		id: 103,
        name: "ELV Solution",
        logo: publicUrl + "assets/img/icons/icon-img/27.png",
      },
      {
		id: 104,
        name: "Security",
        logo: publicUrl + "assets/img/icons/icon-img/28.png",
      },
      {
		id: 105,
        name: "IT Racks & Networking",
        logo: publicUrl + "assets/img/icons/icon-img/26.png",
      },
      {
		id: 106,
        name: "Cinema Solution",
        logo: publicUrl + "assets/img/icons/icon-img/24.png",
      },
    ];

    return (
      <div className={customClass}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Our Services
                </h6>
                <h1 className="section-title">Our Main Focus</h1>
              </div>
            </div>
          </div>
          <div className="row ltn__custom-gutter--- justify-content-center go-top">
            {list.map((value, key) => {
              return (
                <React.Fragment key={key}>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                      <div className="ltn__feature-icon animated">
                        <img className="animated fadeIn" src={value.logo} alt="#" />
                      </div>
                      <div className="ltn__feature-info animated fadeIn">
                        <h3>
                          <Link to={`/service-details/${value?.id}`}>{value.name}</Link>
                        </h3>
                        {/* <p>over 1 million+ homes for sale available on the website, we can match you with a house you will want to call home.</p> */}
                        <Link
                          className="ltn__service-btn"
                          to={`/service-details/${value?.id}`}
                        >
                          View More <i className="flaticon-right-arrow" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default FeaturesV1;
